module.exports = __webpack_public_path__ + "static/media/appointmentList.10838943.svg";